<div>
	<a class="tt" [routerLink]="routerLink">{{ text }}</a>
</div>
